import { BaseScript } from "./BaseScript";

export class RegexpScript extends BaseScript {

	regex: RegExp | null = null;

	/**
	 * Запустить скрипт в контексте hostObject
	 */
	runScript = () => {
		if ( !this.Content ) return null;
		let result = null;
		try {
			// eslint-disable-next-line
			this.regex = this.regex || new RegExp( this.Content.trim().replace("\s+", ""), 'i' );
			if ( !!this.regex ) {
				const val = this.contextElement.DescriptorKey === "SimpleAttachmentViewModel" 
					? this.contextElement.getValue()[0]?.name
					: this.contextElement.getValue();
				const result = this.regex.test( val );
				return result;
			} 
		}
		catch ( e: any ) {
			console.log( e );
		}
		return result;
	};
};
